const doc = [({"da":({"js":({"admin":({"people":({"table":({"contact_id":"Kontakt ID"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;